import * as React from 'react';
import { Card } from 'material-ui/Card';
import { get, differenceBy, unionBy } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import remote from '@inqool/uas-web-core/es/components/controls/remote';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withProps, withHandlers } from 'recompose';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { AutoCompleteField, AutoComplete, ToggleField, Toggle } from '@components/form';

import { required } from '@utils/validators';
import { connect } from 'react-redux';

const enhance = compose<any, any>(
  connect(
    state => ({
      replacements: formValueSelector('work-positions-form')(state, 'replacements'),
      id: formValueSelector('work-positions-form')(state, 'id')
    }),
    dispatch => {
      return {
        changeFieldValue: value => dispatch(change('work-positions-form', 'replacements', value))
      };
    }
  ),
  withHandlers({
    onSubmit: ({ changeFieldValue, replacements, closeItem }) => formData => {
      if (get(formData, 'replacement')) {
        changeFieldValue(unionBy(replacements, [get(formData, 'replacement', null)], o => get(o, 'id')));
      }
      closeItem();
    }
  }),
  withProps({ url: '/metropolis/api/hr/work-positions' }),
  remote,
  withProps(({ items, id, replacements }) => ({
    items: differenceBy(items, [{ id }, ...replacements], o => get(o, 'id'))
  })),
  reduxForm({
    form: 'work-positions-replacements-form'
  })
);

const View: React.SFC<any> = ({ items, closeItem, ...props }) => (
  <div>
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={12}>
              <AutoCompleteField
                component={AutoComplete}
                name="replacement"
                label="Náhradník *"
                items={items}
                labelFunction={o => get(o, 'name')}
                validate={[required]}
              />
            </Col>
            <Col md={12}>
              <ToggleField
                component={Toggle}
                name="active"
                label="Aktivní"
                labelPosition="right"
                onToggle={(_, value) => {
                  props.dispatch(change('work-positions-replacements-form', 'active', value));
                }}
                style={{ margin: '10px 0' }}
              />
            </Col>
          </Row>
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const WorkPositionsReplacementsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-workPositions/WorkPositionsReplacementsForm.tsx